<script>
   /****************************************************************/
   /* PlotRegcoeffs                                                */
   /* --------------------                                         */
   /* shows plot with PLS loadings                                 */
   /****************************************************************/

   import { Segments } from 'svelte-plots-basic/2d';
   import { vector, Matrix } from 'mdatools/arrays';
   import { mrange, range } from 'mdatools/stat';
   import { AXIS_COLOR, getLimX, LOADINGS_LINE_COLOR  } from './Defaults.js';

   import PlotSeries from './PlotSeries.svelte';
   import Axes from './Axes.svelte';
   import { csvRow, downloadCSV } from '../utils.js';


   let {
      params,                        // JSON with main plot parameters
      callbacks,                     // JSON with all callback methods
      props,                         // JSON with main properties (model, results, dataset)
      selected,                      // ID of selected object
   } = $props();

   // get model object from properties
   let model = $derived(props ? props.model : null);
   const ncomp = $derived(props.ncomp ? props.ncomp : 1);

   // get array with coefficients and convert it to matrix
   let coeffsVec = $derived(model && ncomp > 0 ? model.coeffs.subarray(
      (ncomp - 1) * model.npred * model.nresp,
      (ncomp - 1) * model.npred * model.nresp + model.npred * model.nresp)
   : null);

   let coeffs = $derived(coeffsVec ? new Matrix(coeffsVec, model.npred, model.nresp) : null);

   // get values and indices for x-variables
   const axisValues = $derived(model ? vector(model.xvarvalues) : null);
   const axisIndices = $derived(model ? vector(model.xvarindices) : null);
   const xlabels = $derived(model ? model.xvarlabels : null);
   const xAxisLabel = $derived(model ? model.varvaluesName + (model.varvaluesUnits ? ', ' + model.varvaluesUnits : '') : '');

   const xValues = $derived(params.plotType === 'h' ? axisIndices : axisValues);
   const yValues = $derived(coeffs ? coeffs.getcolumn(params.resp) : null);
   const xLabel = $derived(params.plotType === 'h' ? 'Predictors' : xAxisLabel);


   const titleSuffix = $derived(props.ncomp ? ' (A = ' + props.ncomp + ')' : '');
   const title = $derived(model ? 'Regression coefficients for ' + model.varlabels[params.resp - 1] + titleSuffix : '');

   const limX = $derived(getLimX(xValues, params.plotType, model.varrev));
   const limY = $derived(yValues ? mrange(yValues, 0.075) : [0, 1]);
   const yLabel = 'Coefficients';

   // name of the image and CSV files
   const fileName = 'plot-regcoeffs';

   // method for creating CSV version of the plot data
   function downloadCSVCallback() {
      const { sep, dec } = Object.values(props.data)[0];
      let out = csvRow(['Labels', xLabel, title], sep, dec);
      for (let i = 0; i < xlabels.length; i++) {
         out += csvRow([xlabels[i], xValues.v[i], yValues.v[i]], sep, dec);
      }
      downloadCSV(out, fileName);
   }
</script>

{#if xValues && yValues }
<Axes {xLabel} {yLabel} {limX} {limY} {title} whole={params.plotType==='h'} {fileName}
   {downloadCSVCallback}>

   <!-- axis lines (x = 0 and y = 0) -->
   <Segments xStart={[limX[0]]} xEnd={[limX[1]]} yStart={[0]} yEnd={[0]} lineColor={AXIS_COLOR} />

   <!-- data points  -->
   <PlotSeries
      {xValues}
      {yValues}
      {selected}
      plotType={params.plotType}
      showLabels={params.showLabels}
      mainColor={LOADINGS_LINE_COLOR}
      labels={xlabels}
      shortenLabels={false}
   />


</Axes>
{/if}
